export default "__VITE_ASSET__taPfiiFX__"